import Head from 'next/head';

interface Props {
  children: React.ReactNode;
  title?: string;
  description?: string;
  url?: string;
  ogImage?: string;
}

export default function Page({ children, title, description = '', url = '', ogImage }: Props) {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        {title && <title>{title}</title>}
        <meta name="description" content={description} />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="icon" href="/favicon.ico" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={title || ''} />
        <meta property="og:description" content={description} />
        {ogImage && (
          <>
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="twitter:image" content={ogImage} />
          </>
        )}
        <meta name="twitter:site" content={url} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      {children}
    </>
  );
}
